module.exports = __webpack_public_path__ + "static/img/Megaward.53d2d07e.png";